export interface CurrencyConversionFormState {
  conversionDate: string;
  fromCurrency: string;
  fromAmount: number | null;
  toCurrency: string;
  toAmount: number | null;
}

export interface CurrencyConversionErrors {
  conversionDate?: string;
  fromCurrency?: string;
  fromAmount?: string;
  toCurrency?: string;
  toAmount?: string;
}

function amountError(amount: number | null): string | undefined {
  if (amount == null) return 'Required';
  if (amount <= 0) return 'Must be greater than 0';
  return undefined;
}

/** Validates a conversion before it is sent. */
export function validateCurrencyConversion(
  state: CurrencyConversionFormState
): CurrencyConversionErrors {
  const errors: CurrencyConversionErrors = {};

  if (!state.conversionDate) {
    errors.conversionDate = 'Required';
  }
  if (!state.fromCurrency) {
    errors.fromCurrency = 'Required';
  }
  if (!state.toCurrency) {
    errors.toCurrency = 'Required';
  }

  const fromAmountError = amountError(state.fromAmount);
  if (fromAmountError) errors.fromAmount = fromAmountError;

  const toAmountError = amountError(state.toAmount);
  if (toAmountError) errors.toAmount = toAmountError;

  if (
    state.fromCurrency &&
    state.toCurrency &&
    state.fromCurrency === state.toCurrency
  ) {
    errors.toCurrency = 'Must differ from the currency being converted';
  }

  return errors;
}

export function hasAnyError(errors: CurrencyConversionErrors): boolean {
  return Object.values(errors).some((error) => error !== undefined);
}
